import { AbstractControl } from '@angular/forms';

export class BpsEmailValidator {
  static restricted(control: AbstractControl): { [key: string]: boolean } | null {
    const restrictedEmailDomainsListObj: Object = sessionStorage.getItem("restrictedEmailDomains");

    if ((restrictedEmailDomainsListObj ?? false) && restrictedEmailDomainsListObj !== "null") {
      const restrictedEmailDomainsList: string[] = sessionStorage.getItem("restrictedEmailDomains").split(',');
      const restrictedEmailDomains = restrictedEmailDomainsList.map(domain => domain.trim().toLowerCase());

      const email = control.value as string;
      if ((email ?? false) && (email !== null)) {
        const emailParts = email.split('@');
        var emailDomain = emailParts[1];
        emailDomain = emailDomain ? emailDomain.trim().toLowerCase() : null;

        if (emailDomain && restrictedEmailDomains.includes(emailDomain)) {
          return { restricted: true };
        } else {
          return null;
        }
      } else return null;
    } else {
      return null;
    }

  }
}